<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-concierge-bell card-file-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data">

        <div v-if="node.data.templateName">
          <div class="typing_delay clearfix mb-2 p-1 pl-3 pr-3" v-if="node.data.IsTypingOnDisplayChecked && node.data.templateName">
            <p class="typing_display float-left mb-0 p-0 pr-1">
              <img :src="baseUrl + 'assets/pre-loader/typing_on.gif'" height="9px" width="20px"> {{ typing_display }}
            </p>
            <p class="delay_time float-right mb-0" v-if="node.data.delayReplyFor">
              {{ node.data.delayReplyFor }} {{ sec }}
            </p>
          </div>
  
          <p class="text-center mb-2 postback_title" v-if="node.data.templateName">
            {{node.data.templateName}}
          </p>
  
          <div class="list-group mt-2">
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedLabelTexts(node)">   
              <small class="text-muted">{{ button_html_add_label }}</small>
              <p class="mb-0"> {{ getSelectedLabelTexts(node) }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedRemoveLabelTexts(node)">   
              <small class="text-muted">{{ button_html_remove_label }}</small>
              <p class="mb-0"> {{ getSelectedRemoveLabelTexts(node) }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValue && node.data.sequenceIdText">   
              <small class="text-muted">{{ button_html_add_sequence }}</small>
              <p class="mb-0"> {{ node.data.sequenceIdText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValueRemove && node.data.sequenceIdTextRemove">   
              <small class="text-muted">{{ button_html_remove_sequence }}</small>
              <p class="mb-0"> {{ node.data.sequenceIdTextRemove }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationGroupId && node.data.conversationGroupText">   
              <small class="text-muted">{{ button_html_conversation_group }}</small>
              <p class="mb-0"> {{ node.data.conversationGroupText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationUserId && node.data.conversationUserText">   
              <small class="text-muted">{{ button_html_conversation_user }}</small>
              <p class="mb-0"> {{ node.data.conversationUserText }}</p>
            </span>
            <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.buttonWebhookUrl && node.data.buttonWebhookUrl">   
              <small class="text-muted"><a>{{ button_html_label_webhook_url }}</a></small>
              <p class="mb-0">
                <a :href="node.data.buttonWebhookUrl" :title="node.data.buttonWebhookUrl" target="_BLANK">{{node.data.buttonWebhookUrl.length>40 ? node.data.buttonWebhookUrl.slice(0, 40)+'...' : node.data.buttonWebhookUrl}}</a>
              </p>
            </span>
          </div>
        </div>
        <div v-else class="double-click-div text-center">
          <img :src="icon_doubletap" :title="double_click_for_settings">
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div 
            class="output text-right" 
            v-for="output in outputs()"
            :ref="output.key === otnSingleOutputSequence ? 'otnSequenceOutput' : ''" 
            :key="output.key"
            :class="[toggleSpecificSocket(node), hasConnection(output) ? 'has-connection' : '']"
          >
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>

        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import { templateComponentMethods, updateNodeConnections } from '../../utils/functions'

export default {
  name: 'OtnSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,
    templateName: lang.otn_single_template_template_name,
    labelNames: lang.otn_single_template_labels,
    sequenceName: lang.otn_single_template_sequence_name,
    
    otn_single_html_labels: lang.otn_single_html_labels,
    otn_single_template_sequence_name: lang.otn_single_template_sequence_name,
    button_html_add_label: lang.button_html_add_label,
    button_html_remove_label: lang.button_html_remove_label,
    button_html_add_sequence: lang.button_html_add_sequence,
    button_html_remove_sequence: lang.button_html_remove_sequence,
    button_html_conversation_group: lang.button_html_conversation_group,
    button_html_conversation_user: lang.button_html_conversation_user,
    button_html_label_webhook_url: lang.button_html_label_webhook_url,
    button_html_label_action_type: lang.button_html_label_action_type,
    button_html_label_web_url: lang.button_html_label_web_url,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,

    otnSingleOutputSequence: CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE,
  }),

  methods: {
    ...templateComponentMethods,

    isSequenceSocketHidable(node, output) {
      return !! node.buttonNodeSequenceSocketStatus && (output.key === CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE)
    },

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    },
    getSelectedRemoveLabelTexts(node) {
      const labelIdTextsArrayRemove = node.data.labelIdTextsArrayRemove || []
      return labelIdTextsArrayRemove.join(', ')
    },

    toggleSpecificSocket(node) {
      const that = this
      if(this.$refs.otnSequenceOutput) {
        const element = that.$refs.otnSequenceOutput[0]
        if('newSequence' === node.data.sequenceIdValue) {
          element.classList.remove('d-none')
          element.classList.add('d-block')
        } else {
          element.classList.remove('d-block')
          element.classList.add('d-none')
          setTimeout(function() {
            element.classList.remove('d-block')
            element.classList.add('d-none')
          }, 100)
        }
      }
    },
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>